<!-- chat.component.html -->
<ng-container
  *ngTemplateOutlet="chatTmpl; context: { modal: activeModal }"
></ng-container>

<!-- Templates -->

<!-- Chat -->
<ng-template #chatTmpl let-modal="modal">
  <div class="chat-container" *ngIf="currentUser">
    <div class="chat-header">
      <div class="title">
        <h2 *ngIf="currentChannel">
          <span translate
            >chat.channel.{{ currentChannel.entityType }}.label</span
          >
          #{{ currentChannel.entityId }}
        </h2>
        <h2 *ngIf="!currentChannel">**** unknow channel ****</h2>
      </div>
      <div class="action">
        <fa-icon
          *ngIf="!modal"
          [icon]="['fas', 'expand']"
          (click)="openModal(modalChat)"
        ></fa-icon>
        <fa-icon
          *ngIf="modal"
          [icon]="['fas', 'xmark']"
          (click)="closeModal()"
        ></fa-icon>
      </div>
    </div>
    <div class="messages" #scrollableMsg name="messages">
      <div
        *ngFor="let message of messages"
        class="message-wrapper"
        [ngClass]="{ 'current-user': message.createdBy === currentUser.id }"
      >
        <div class="avatar" *ngIf="message.createdBy !== currentUser.id">
          {{ getUserInitials(message.createdBy) }}
        </div>
        <div class="message-content">
          <div class="message-header">
            <span class="user">{{ getUserName(message.createdBy) }}</span>
          </div>
          <p class="message-text">{{ message.message }}</p>
          <span class="timestamp">{{
            message.createdAt | date : "dd/MM/yyyy HH:mm"
          }}</span>
        </div>
      </div>
    </div>
    <div class="input-area">
      <input
        [(ngModel)]="newMessage"
        (keyup.enter)="sendMessage()"
        placeholder="Tapez votre message..."
        [disabled]="isMessageSending"
      />
      <button (click)="sendMessage()" [disabled]="isMessageSending">
        <svg
          *ngIf="!isMessageSending"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
        </svg>
        <span
          *ngIf="isMessageSending"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalChat>
  <div class="modal-chat">
    <ng-container
      *ngTemplateOutlet="chatTmpl; context: { modal: activeModal }"
    ></ng-container>
  </div>
</ng-template>
